import * as Square from "@square/web-sdk";
import { useEffect, useState } from "react";
import { genProcessDataOfSquarePay } from "../../gateway/payment/gatewayPaymentQueries";

const SquarePayArea = ({ onOk }: { onOk?: (x: { token: string }) => void }) => {
  const [paymentForm, setPaymentForm] = useState<Square.Card | null>(null);
  const [token, setToken] = useState<string | undefined>(undefined);
  const [error, setError] = useState<string | undefined>(undefined);
  const [isPending, setIsPending] = useState(false);
  useEffect(() => {
    async function initializeSquare() {
      try {
        const data: SquarePayProcessDataDTO = await genProcessDataOfSquarePay();
        const payments = await Square.payments(data.appId, data.locationId);
        if (!payments) {
          console.error("Square Payments failed to initialize");
          return;
        }
        const card = await payments.card();
        await card.attach("#card-container");

        setPaymentForm(card);
      } catch (error) {
        console.error("Square Payment initialization failed:", error);
      }
    }

    initializeSquare();
  }, []);

  const handlePayment = async () => {
    if (!paymentForm) return;

    try {
      setIsPending(true);
      const result = await paymentForm.tokenize();
      if (result.status === "OK" && result.token) {
        setToken(result.token);
        console.log("Payment token:", result.token);
        onOk?.({ token: result.token });
        // Send this token to your backend for payment processing
      } else {
        // alert("Tokenization failed");
        console.error("Tokenization failed:", result.errors);
        setError("Tokenization failed: " + JSON.stringify(result.errors));
      }
    } catch (error) {
      console.error("Payment error:", error);
      alert("Payment error: " + error);
    }
    setIsPending(false);
  };

  return (
    <div>
      {!paymentForm && <p className="mb-4">Loading...</p>}
      <div id="card-container"></div>
      <button
        type="button"
        disabled={isPending}
        onClick={handlePayment}
        className="flex h-[3.13rem] w-full cursor-pointer flex-row items-center justify-center self-stretch whitespace-nowrap rounded-[1.5rem] bg-gray-900 px-[2.13rem] text-center text-sm font-semibold text-white sm:text-base"
      >
        Pay by card
      </button>
      {/* {token && <p>Payment Token: {token}</p>} */}
      {error && <p className="mt-2 text-sm text-[#CC0023]">Error</p>}
    </div>
  );
};

export default SquarePayArea;
